export const productCategories = {
  accessory: 'Accessory',
  outdoor: 'Outdoor',
  babyAndKids: 'Baby & Kids',
  beauty: 'Beauty',
  clothing: 'Clothing',
  drink: 'Drink',
  food: 'Food',
  hair: 'Hair Care',
  health: 'Health & Wellness',
  home: 'Home',
  personal: 'Personal Care',
  pets: 'Pets',
  skin: 'Skin Care',
  supplements: 'Supplements',
  tech: 'Tech',
} as const;
